import React, { Component } from 'react'
import { connect } from 'react-redux'

import { isiOS } from '../../../constants'

// actions
import { triggerPopup } from '../../../actions/backdrop'
import { getCarRentalContract, updateCarRentalContract } from '../../../actions/carrentalcontracts'

// utils
import { translation } from '../../../utils/helpers'
import { renderFullDate } from '../../../utils/time'
import { isTouchDevice } from '../../../utils/detect'

// Components
import OverlayHeader from '../../components/OverlayHeader'

// modals
import CarRentalContractModal from '../../modals/CarRentalContractModal'

// Elements
import Overlay from '../../elements/overlay'
import Row from '../../elements/row'
import Col from '../../elements/col'
import Panel from '../../elements/panel'
import Text from '../../elements/text'
import Check from '../../elements/check'
import Radio from '../../elements/radio'
import Switch from '../../elements/switch'
import LabelWrapper from '../../elements/labelWrapper'
import Textarea from '../../elements/textarea'
import BottomBar from '../../elements/bottomBar'
import OverlayContent from '../../elements/overlayContent'
import Inline from '../../elements/inline'
import Actions from '../../elements/actions'
import Icon from '../../elements/icon'
import Button from '../../elements/button'
import { ElementIcons } from '../../elements/icons'

// styles
import './carrentalcontractoverlay.scss'

class CarRentalContractOverlay extends Component {
  constructor (props) {
    super(props)
    this.state = {
      carOwnerPhoneCount: 1,
      conditionsEdit: false,
      Company: {
        Name: '', // 'Viborg Pladeværksted',
        Address: '', // 'Vejnavn 00',
        Zip: '', // '0000',
        City: '', // 'Viborg',
        CVR: '' // '000000000'
      },
      Car: {
        Nr: '', // '2',
        RegNumber: '', // 'AA 11 111',
        Brand: '', // 'Toyota',
        Model: '' // 'Aygo'
      },
      Insurance: {
        Kasko: true,
        SelfRiskCoverage: false,
        SelfRiskCoverageAmount: 0
      },
      Renter: {
        Name: '', // 'Elena',
        Address: '', // 'Vejnavn 21',
        Zip: '', // '8830',
        City: '', // 'Tjele',
        Phones: [], // '12345678',
        Mail: '', // 'elena@itpilot.dk',
        DriverLicense: '', // '12345600',
        CVR: '' // '000111000'
      },
      Drivers: [{ Name: '', DriverLicense: '' }, { Name: '', DriverLicense: '' }],
      Periods: [{ Start: null, End: null }],
      Rent: {
        Fuel: false,
        Tank: 1,
        UpToKm: null, // '80',
        ExtraKm: null // '20'
      },
      KmAtStart: null, // '50',
      Conditions: null // ''
    }

    this.md = new window.MobileDetect(window.navigator.userAgent)
    this.onChange = this.onChange.bind(this)
    this.openPopup = this.openPopup.bind(this)
    this.closePopup = this.closePopup.bind(this)
    this.getCarRentalContract = this.getCarRentalContract.bind(this)
    this.updateCarRentalContract = this.updateCarRentalContract.bind(this)
    this.toggleEditConditions = this.toggleEditConditions.bind(this)
    this.setDocHeight = this.setDocHeight.bind(this)
  }

  componentDidMount () {
    // console.log('componentDidMount', this.props)
    if (this.props.order && this.props.carRentalId) {
      this.getCarRentalContract(this.props.carRentalId, true)
    }
    // let isAndroid = this.md.is('AndroidOS')
    // let isIOS = this.md.is('iPhone')
    let isPhone = this.md.phone()
    if (isPhone) {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      document.documentElement.scrollTop = 20
      window.addEventListener('resize', this.setDocHeight)
      window.addEventListener('orientationchange', this.setDocHeight)
    }
  }

  setDocHeight () {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    let height1 = document.documentElement.clientHeight
    let height2 = window.innerHeight
    let dif = Math.abs(height1 - height2)
    if (dif !== 0) {
      vh = (window.innerHeight - 56) * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
  }

  componentWillUnmount () {
    let isPhone = this.md.phone()
    if (isPhone) {
      window.removeEventListener('resize')
      window.removeEventListener('orientationchange')
    }
  }

  componentWillReceiveProps (nextProps) {
    // console.log('componentWillReceiveProps', this.props, nextProps)
    if (typeof nextProps.carRentalId === 'number' && this.props.carRentalId !== nextProps.carRentalId) {
      this.getCarRentalContract(nextProps.carRentalId, true)
    }
  }

  getCarRentalContract (carRentalId, forceNew) {
    // console.log('getCarRentalContract', this.props, carRentalId)
    if (typeof this.props.order === 'object' && typeof carRentalId === 'number') {
      this.props.getCarRentalContract(this.props.order.Id, carRentalId, forceNew).then(res => {
        this.setState({
          ...this.state,
          ...res.data
        })
      })
    }
  }

  updateCarRentalContract () {
    if (this.props.order.Id && this.props.carRentalId) {
      let data = {
        OrderId: this.props.order.Id,
        CarRentalId: this.props.carRentalId,
        Renter: this.state.Renter,
        Insurance: this.state.Insurance,
        Rent: this.state.Rent,
        Drivers: this.state.Drivers,
        KmAtStart: this.state.KmAtStart
      }
      if (this.state.conditionsEdit) {
        data.Conditions = this.state.Conditions
      }

      let carOwnerPhoneCount = this.state.carOwnerPhoneCount
      carOwnerPhoneCount = data.Renter.Phones.length
      // console.log('Update contract: ', data)

      this.props.updateCarRentalContract(data).then(res => {
        let data = res.data
        let phoneCount = data.Renter.Phones.length

        if (phoneCount > carOwnerPhoneCount) carOwnerPhoneCount = phoneCount
        for (let i = phoneCount; i < carOwnerPhoneCount; i++) {
          data.Renter.Phones.push('')
        }
        this.setState({
          ...this.state,
          ...data,
          carOwnerPhoneCount
        })
      })
    }
  }

  openPopup (e) {
    e.preventDefault()
    this.setState({
      carrentalcontractmodal: true
    })
    this.props.triggerPopup(true)
  }

  closePopup () {
    this.props.triggerPopup(false)
    this.setState({
      carrentalcontractmodal: false
    })
  }

  onChange (e) {
    // value
    let value = e.target.value
    let doUpdate = false
    if (e.target.type === 'checkbox') {
      value = e.target.checked
      doUpdate = true
    }
    if (e.target.type === 'radio') {
      value = parseInt(e.target.value)
      doUpdate = true
    }
    // name
    let names = e.target.name.split('.')
    // console.log('names.length ', names.length)
    let nameOuter = names[0]
    let namesInner = names[1]
    if (names.length > 1) {
      this.setState({
        [nameOuter]: {
          ...this.state[nameOuter],
          [namesInner]: value
        }
      }, () => doUpdate && this.updateCarRentalContract())
    } else {
      this.setState({
        [nameOuter]: value
      }, () => doUpdate && this.updateCarRentalContract())
    }
  }

  toggleEditConditions () {
    this.setState({
      conditionsEdit: !this.state.conditionsEdit
    })
  }

  renderHeader () {
    let car = this.state.Car
    return (
      <OverlayHeader overlayId='CarRentalContractOverlay' onClose={this.props.onClose}>
        <div className='top topHeaderInfo'>
          <div>
            <span>{`${car.Nr} - ${car.RegNumber}`}</span>
          </div>
        </div>
      </OverlayHeader>
    )
  }

  renderLender () {
    const { Company } = this.state
    return (
      <Panel title={translation(16782)}>
        <Text name='Company.Name' value={Company.Name || ''} disabled labelText={translation(16790)} />
        <Text name='Company.Address' value={Company.Address || ''} disabled labelText={translation(25)} />
        <Text name='Company.Zip' value={Company.Zip || ''} disabled labelText={translation(16791)} />
        <Text name='Company.City' value={Company.City || ''} disabled labelText={translation(37)} />
        <Text name='Company.CVR' value={Company.CVR || ''} disabled labelText={translation(41)} />
      </Panel>
    )
  }

  renderCar () {
    const { Car } = this.state
    return (
      <Panel title={translation(629)}>
        <Text name='Car.Nr' value={Car.Nr || ''} disabled labelText={translation(16792)} />
        <Text name='Car.RegNumber' value={Car.RegNumber || ''} disabled labelText={translation(2005)} />
        <Text name='Car.Brand' value={Car.Brand || ''} disabled labelText={translation(145)} />
        <Text name='Car.Model' value={Car.Model || ''} disabled labelText={translation(146)} />
      </Panel>
    )
  }

  renderInsurance () {
    const { Insurance } = this.state
    // let selfRiskPrice = 50 // TODO: get from api
    return (
      <Panel title={translation(16786)}>
        <Check name='Insurance.Kasko' checked={Insurance.Kasko} onChange={this.onChange} labelText={translation(16793)} />
        <Check name='Insurance.SelfRiskCoverage' checked={Insurance.SelfRiskCoverage} onChange={this.onChange} labelText={`${translation(16794)} ${translation(this.props.currencyCode)} ${Insurance.SelfRiskCoverageAmount} ${translation(971)}`} />
      </Panel>
    )
  }

  renderPhones () {
    let phones = this.state.Renter.Phones

    const newNumber = (e) => {
      e.preventDefault()
      let carOwnerPhoneCount = this.state.carOwnerPhoneCount
      if (phones.length > carOwnerPhoneCount) carOwnerPhoneCount = phones.length
      if (carOwnerPhoneCount < 4) {
        carOwnerPhoneCount++
        phones.push('')
        this.setState({
          carOwnerPhoneCount
        })
      }
    }

    const onChangePhone = (key, e) => {
      phones[key] = e.target.value
      this.setState({
        phones
      })
    }

    const onBlurPhone = (key, e) => {
      phones[key] = e.target.value
      this.setState({
        phones
      }, () => {
        this.updateCarRentalContract()
      })
    }

    return (
      <div>
        {phones.map((val, key) => {
          return (
            <Text name='Text' value={val} key={'number_' + key} labelText={translation('38')} onBlur={onBlurPhone.bind(this, key)} onChange={onChangePhone.bind(this, key)} />
          )
        })}
        <Button style='link' labelText={translation('17899')} disabled={phones.length === 4} onClick={newNumber} />
      </div>
    )
  }

  renderRenter () {
    const { Renter } = this.state
    return (
      <Panel title={translation(16783)}>
        <Text name='Renter.Name' value={Renter.Name || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(30)} />
        <Text name='Renter.Address' value={Renter.Address || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(25)} />
        <Text name='Renter.Zip' value={Renter.Zip || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(16791)} />
        <Text name='Renter.City' value={Renter.City || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(37)} />
        {this.renderPhones()}
        <Text name='Renter.Mail' value={Renter.Mail || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(1052)} />
        <Text name='Renter.DriverLicense' value={Renter.DriverLicense || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(16795)} />
        <Text name='Renter.CVR' value={Renter.CVR || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(41)} />
      </Panel>
    )
  }

  renderDrivers () {
    const { Drivers } = this.state
    const onChange = (e) => {
      let names = e.target.name.split('_')
      let index = parseInt(names[1])
      let drivers = this.state.Drivers
      drivers[index][names[0]] = e.target.value
      this.setState({
        Drivers: drivers
      }, () => {
        // console.log('Drivers: ', this.state.Drivers, 'index changed:', index)
      })
    }
    const mapDrivers = (val, key) => {
      return (
        <div key={key}>
          <Text name={'Name_' + key} value={val.Name || ''} onChange={onChange} onBlur={this.updateCarRentalContract} labelText={`${translation(30)} (${translation(16796).toLowerCase()} ${key + 1})`} />
          <Text name={'DriverLicense_' + key} value={val.DriverLicense || ''} onChange={onChange} onBlur={this.updateCarRentalContract} labelText={translation(16795)} />
        </div>
      )
    }
    return (
      <Panel title={translation(16788)}>
        {Drivers.map(mapDrivers)}
      </Panel>
    )
  }

  renderPeriod () {
    const { Periods } = this.state

    const getDate = (dateTime) => { return dateTime.split(' - ')[0] }
    const getTime = (dateTime) => { return dateTime.split(' - ')[1] }

    const renderPeriod = (p, i) => {
      let start = renderFullDate(p.Start)
      let end = renderFullDate(p.End)

      return (
        <div key={'period_' + i}>
          <LabelWrapper labelText={translation(16771)}>
            <Inline block fillChildNum={[0]}>
              <Text value={getDate(start) || ''} disabled />
              <Text value={getTime(start) || ''} disabled />
            </Inline>
          </LabelWrapper>
          <LabelWrapper labelText={translation(16772)}>
            <Inline block fillChildNum={[0]}>
              <Text value={getDate(end) || ''} disabled />
              <Text value={getTime(end) || ''} disabled />
            </Inline>
          </LabelWrapper>
        </div>
      )
    }
    return (
      <Panel title={translation(16784)}>
        {Periods.map(renderPeriod)}
      </Panel>
    )
  }

  renderRent () {
    const { Rent } = this.state
    return (
      <Panel title={translation(16785)}>
        <Switch name='Rent.Fuel' checked={Rent.Fuel} onChange={this.onChange} labelText={translation(16797)} />
        <LabelWrapper labelText={translation(16798)}>
          <Radio name='Rent.Tank' value={0} checked={Rent.Tank === 0} onChange={this.onChange} labelText={translation(16799)} />
          <Radio name='Rent.Tank' value={1} checked={Rent.Tank === 1} onChange={this.onChange} labelText={'1/4'} />
          <Radio name='Rent.Tank' value={2} checked={Rent.Tank === 2} onChange={this.onChange} labelText={'1/2'} />
          <Radio name='Rent.Tank' value={3} checked={Rent.Tank === 3} onChange={this.onChange} labelText={'3/4'} />
          <Radio name='Rent.Tank' value={4} checked={Rent.Tank === 4} onChange={this.onChange} labelText={translation(16804)} />
        </LabelWrapper>
        <Text name='Rent.UpToKm' value={Rent.UpToKm || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(16800)} />
        <Text name='Rent.ExtraKm' value={Rent.ExtraKm || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(16801)} />
      </Panel>
    )
  }

  renderSummary () {
    const { KmAtStart } = this.state
    return (
      <Panel title={translation(16787)}>
        <Text name='KmAtStart' value={KmAtStart || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} labelText={translation(16802)} />
      </Panel>
    )
  }

  renderRentConditions () {
    const { Conditions } = this.state
    return (
      <Panel title={translation(16789)}>
        <Actions>
          <Icon icon={ElementIcons.Edit} size='t' onClick={this.toggleEditConditions} />
        </Actions>
        <Textarea name='Conditions' disabled={!this.state.conditionsEdit} value={Conditions || ''} onChange={this.onChange} onBlur={this.updateCarRentalContract} />
      </Panel>
    )
  }

  renderActionHeader () {
    return (
      <div className='top renderActionHeader'>
        <span>{translation(16781)}</span>
      </div>
    )
  }

  render () {
    // do not show print button on mobile devies
    let bottomBar = {}
    let isiPadPro = isTouchDevice() && /MacIntel/.test(navigator.platform)
    if (isiOS || isiPadPro || this.md.phone() || this.md.tablet()) {
      bottomBar = <BottomBar
        cancelLabelText={translation(235)}
        onCancelClick={this.props.onClose}
        center
      />
    } else {
      bottomBar = <BottomBar
        actionLabelText={translation(16803)}
        onActionClick={this.openPopup}
        cancelLabelText={translation(235)}
        onCancelClick={this.props.onClose}
        center
      />
    }

    return (
      <Overlay overlayId='CarRentalContractOverlay' extraClassName='carrentalcontract-overlay'>
        {this.renderHeader()}
        <OverlayContent>
          {bottomBar}
          <div className='content'>
            {this.renderActionHeader()}
            <Row>
              <Col>
                {this.renderLender()}
                {this.renderCar()}
                {this.renderInsurance()}
              </Col>
              <Col>
                {this.renderRenter()}
                {this.renderDrivers()}
              </Col>
              <Col>
                {this.renderPeriod()}
                {this.renderRent()}
                {this.renderSummary()}
              </Col>
            </Row>
            <Row>
              <Col>
                {this.renderRentConditions()}
              </Col>
            </Row>
          </div>
        </OverlayContent>
        {this.state.carrentalcontractmodal && <CarRentalContractModal show={this.state.carrentalcontractmodal} contract={this.state} onClose={this.closePopup} currencyCode={this.props.currencyCode} />}
      </Overlay>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    headerInfo: state.common.headerInfo,
    currencyCode: state.common.currencyCode
  }
}

CarRentalContractOverlay.defaultProps = {
  carRentalId: 0
}

export default connect(mapStateToProps, {
  triggerPopup,
  getCarRentalContract,
  updateCarRentalContract
})(CarRentalContractOverlay)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/CarRentalContractOverlay/index.js